import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { WorkerPool } from '@recruitee/common';
import { HttpApiService } from '@recruitee/http';
import { AutoDeleteConfig, GdprAutoConsentCounter } from '@recruitee/http/types';

@Injectable({ providedIn: 'root' })
export class GdprAutoDeleteHttpClient {
  constructor(protected httpApi: HttpApiService, private workerPool: WorkerPool) {}

  public loadCounter(configuration: AutoDeleteConfig): Observable<GdprAutoConsentCounter> {
    return this.httpApi.get(`gdpr/auto_delete/count`, configuration);
  }

  public schedule(): Observable<{ uuid: string }> {
    return this.httpApi.post(`gdpr/auto_delete`);
  }
}
